import { NgModule } from '@angular/core';

import { provideAzureCore, withLoggerAppender, withTracing } from './azure.core';

/**
 * @deprecated use provideAzureCore() instead
 */
@NgModule({
    providers: [provideAzureCore(withTracing(), withLoggerAppender())]
})
export class AzureCoreModule {}
